var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-item',{attrs:{"link":{name: _vm.$t('Шина'),  icon: 'vip_icon icon_agency'}}},[_c('sidebar-item',{attrs:{"link":{name: _vm.$t('Лог шины'),  path: `/journal`,  icon: 'nc-icon nc-chart-pie-36'}}}),_c('sidebar-item',{attrs:{"link":{name: _vm.$t('Администрирование'),  path: `/adminmanager`,  icon: 'nc-icon nc-chart-pie-36'}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }